(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["descriptions-library"] && !Shopify.designMode) return;
  try {
    
  class DescriptionsLibrary {
    constructor(section) {
      if (section.dataset.bdmResourceLibraryInitialized === 'true') {
        return;
      }

      this.section = section;
      this.tabs = Array.from(section.querySelectorAll('[data-brand][role="tab"]'));
      this.cards = Array.from(section.querySelectorAll('[data-resource-card]'));
      this.emptyMessage = section.querySelector('[data-empty-message]');
      this.activeClass = 'is-active';
      section.dataset.bdmResourceLibraryInitialized = 'true';

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectBrand(tab.dataset.brand));
      });

      const defaultTab = this.tabs.find((tab) => tab.classList.contains(this.activeClass)) || this.tabs[0];

      if (defaultTab) {
        this.selectBrand(defaultTab.dataset.brand);
      }
    }

    selectBrand(brand) {
      let visibleCount = 0;

      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.brand === brand;
        tab.classList.toggle(this.activeClass, isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.cards.forEach((card) => {
        const isVisible = card.dataset.brand === brand;
        card.hidden = !isVisible;
        card.classList.toggle('is-hidden', !isVisible);

        if (isVisible) {
          visibleCount += 1;
        }
      });

      if (this.emptyMessage) {
        this.emptyMessage.hidden = visibleCount > 0;
      }
    }
  }

  const initBdmResourceLibraries = (root = document) => {
    if (root.matches && root.matches('[data-descriptions-library]')) {
      new DescriptionsLibrary(root);
    }

    root.querySelectorAll('[data-descriptions-library]').forEach((section) => {
      new DescriptionsLibrary(section);
    });
  };

  initBdmResourceLibraries();

  document.addEventListener('shopify:section:load', (event) => {
    initBdmResourceLibraries(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size' ||
        this.getAttribute('data-sticky-type') === 'absolute';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["point-of-sale-library"] && !Shopify.designMode) return;
  try {
    
  class BdmResourceLibrary {
    constructor(section) {
      if (section.dataset.bdmResourceLibraryInitialized === 'true') {
        return;
      }

      this.section = section;
      this.tabs = Array.from(section.querySelectorAll('[data-brand][role="tab"]'));
      this.cards = Array.from(section.querySelectorAll('[data-resource-card]'));
      this.emptyMessage = section.querySelector('[data-empty-message]');
      this.activeClass = 'is-active';
      section.dataset.bdmResourceLibraryInitialized = 'true';

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectBrand(tab.dataset.brand));
      });

      const defaultTab = this.tabs.find((tab) => tab.classList.contains(this.activeClass)) || this.tabs[0];

      if (defaultTab) {
        this.selectBrand(defaultTab.dataset.brand);
      }
    }

    selectBrand(brand) {
      let visibleCount = 0;

      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.brand === brand;
        tab.classList.toggle(this.activeClass, isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.cards.forEach((card) => {
        const isVisible = card.dataset.brand === brand;
        card.hidden = !isVisible;
        card.classList.toggle('is-hidden', !isVisible);

        if (isVisible) {
          visibleCount += 1;
        }
      });

      if (this.emptyMessage) {
        this.emptyMessage.hidden = visibleCount > 0;
      }
    }
  }

  const initBdmResourceLibraries = (root = document) => {
    if (root.matches && root.matches('[data-bdm-resource-library]')) {
      new BdmResourceLibrary(root);
    }

    root.querySelectorAll('[data-bdm-resource-library]').forEach((section) => {
      new BdmResourceLibrary(section);
    });
  };

  initBdmResourceLibraries();

  document.addEventListener('shopify:section:load', (event) => {
    initBdmResourceLibraries(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
